module.exports = __webpack_public_path__ + "img/icon04.6c00c93a.svg";